<template>
    <div class="okraina-rpbb" v-ripple.touchstart="'rgba(255, 255, 255, 0.15)'" :class="{ in: quantity > 0 }"
        @click="onAddClick">
        <span v-if="quantity == 0" class="add">
            В список
        </span>
        <template v-else>
            <div class="minus" @click.stop="onMinusClick">
                <div class="decrease"></div>
            </div>
            <span class="cnt">{{ quantity }}</span>
            <div class="plus" @click.stop="onPlusClick">
                <div class="increase"></div>
            </div>
        </template>
    </div>
</template>

<script>
import rest from "@/plugins/rest";
import bus from "@/plugins/bus";

import { mapGetters } from "vuex";

export default {
    name: "okraina-retail-product-buy-btn",
    components: {},
    data() {
        return {
            quantity: 0,
            timer: 0
        }
    },
    props: {
        productId: {
            type: [Number, String],
            default() {
                return 0;
            },
        },

        checkQuantity: {
            type: String,
            default() {
                return "N";
            },
        },
        maxQuantity: {
            type: Number,
            default() {
                return 0;
            },
        },
        maxQuantityMessage: {
            type: String,
            default() {
                return ""
            }
        },
    },
    computed: {

        ...mapGetters({
            retailShopId: "retail/getShopId"
        }),

        inBasket() {
            return this.$store.getters["retail/inBasket"](this.productId);
        },
        basketItem() {
            return this.$store.getters["retail/getProductInBasket"](this.productId);
        },
        /**
         * Кол-во в общем хранилище данных - чтобы отслеживать из-менение кол-ва у одного и того же товара если их несколько на странице
         */
        basketQuantity() {
            return this.basketItem ? this.basketItem.quantity : 0;
        }

    },
    watch: {
        basketQuantity: function () {
            if (this.timer == 0) {
                this.quantity = this.basketQuantity;
            }
        }
    },

    methods: {

        /**
         * Первое добавление в корзину
         */
        onAddClick() {
            //если товара ещё нет в корзине
            if (!this.inBasket) {
                this.onPlusClick();
            }
        },

        /**
         * Добавление/Увеличение
         */
        onPlusClick() {
            //если включен кол-венный учёт и количество в корзине уже равно или больше чем максимально возможно
            if (
                this.checkQuantity == "Y" &&
                this.quantity >= this.maxQuantity
            ) {
                //показываем сообщение об ошибке
                bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: this.maxQuantityMessage ? this.maxQuantityMessage : "Остаток товара " + this.maxQuantity + " шт." });
                return;
            }

            this.quantity += 1;
            this.saveByTimer();
        },

        /**
         * Уменьшение/Удаление
         */
        onMinusClick() {
            if (this.quantity > 0) {
                this.quantity -= 1;
                this.saveByTimer();
            }

        },

        /**
         * Сохранение с задержкой (чтобы учесть несколько одновременных кликов +/-)
         */
        saveByTimer() {

            if (this.timer > 0) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.save();
                this.timer = 0;
            }, 500)

        },

        save() {

            let action = "add";
            if (this.quantity == 0) {
                if (this.basketItem) {
                    action = "delete";
                } else {
                    return;
                }
            } else {
                if (this.basketItem) {
                    action = "update";
                }
            }

            let savedQuantity = this.quantity;
            rest
                .call("retail.basket." + action, {
                    method: "post",
                    data: {
                        SHOP_ID: this.retailShopId,
                        PRODUCT_ID: this.productId,
                        QUANTITY: this.quantity
                    },
                })
                .then((data) => {

                    if (data.SUCCESS) {

                        //изменяем кол-во в корзине
                        this.$store.dispatch("retail/updateBasketItem", {
                            id: this.productId,
                            quantity: savedQuantity
                        })

                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                        this.quantity = this.basketQuantity;
                    }
                });

        }
    },

    created() {
        if (this.basketItem) {
            this.quantity = this.basketItem.quantity;
        }
    },
};
</script>

<style lang="scss">
.okraina-rpbb {
    position: relative;

    border-radius: 8px;
    text-align: center;
    padding: 7px 7px;
    font-weight: 600;
    font-size: 14px;
    background-color: var(--color-buy-background);
    color: var(--color-buy-color);
    border: 1px solid var(--color-buy-background);

    cursor: pointer;


    &.in {
        background-color: var(--color-buy-background-in);
        color: var(--color-buy-color-in);
        border-color: var(--color-buy-background-in);
        cursor: default;
    }

    .minus {
        position: absolute;
        top: 0px;
        left: 0px;
        bottom: 0px;
        width: 35px;
        z-index: 1;
        cursor: pointer;

        .decrease {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: var(--color-buy-color-in);
            width: 11px;
            height: 2px;
        }
    }

    .plus {
        position: absolute;
        top: 0px;
        right: 0px;
        bottom: 0px;
        width: 35px;
        z-index: 2;
        cursor: pointer;

        .increase {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: var(--color-buy-color-in);
            width: 10px;
            height: 2px;

            &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: var(--color-buy-color-in);
                height: 10px;
                width: 2px;

            }
        }

    }

}
</style>
